import * as Yup from "yup";
import { useIntl } from "react-intl";
import {
  validatePhone,
  validateEmail,
} from "../../../../../../../../util/validators/yupValidators";

export default function useContactRelationModalFormValidation() {
  const { formatMessage } = useIntl();

  const validationSchema = Yup.object({
    First_Name: Yup.string().when("op", {
      is: "new",
      then: Yup.string()
        .matches(
          /^[a-zA-Z\s\u00C0-\u017F]*$/,
          formatMessage({
            id: "ContactRelationForm.InvalidName",
            defaultMessage: "Nombre no válido",
          })
        )
        .required(
          formatMessage({
            id: "ContactRelationForm.RequiredName",
            defaultMessage: "El nombre es obligatorio",
          })
        ),
    }),
    Last_Name: Yup.string().when("op", {
      is: "new",
      then: Yup.string()
        .matches(
          /^[a-zA-Z\s\u00C0-\u017F]*$/,
          formatMessage({
            id: "ContactRelationForm.InvalidSurname",
            defaultMessage: "Apellido no válido",
          })
        )
        .required(
          formatMessage({
            id: "ContactRelationForm.RequiredSurname",
            defaultMessage: "El apellido es obligatorio",
          })
        ),
    }),
    Phone: Yup.string().when("op", {
      is: "new",
      then: Yup.string()
        .required(
          formatMessage({
            id: "ContactRelationForm.phoneRequired",
            defaultMessage: "El teléfono es obligatorio",
          })
        )
        .test(
          "valid-phone",
          formatMessage({
            id: "ContactRelationForm.phoneMustBeValid",
            defaultMessage: "El teléfono no es válido",
          }),
          validatePhone
        )
        .when("phone_used_by", {
          is: (phoneUsedBy) => {
            const retVal = !!phoneUsedBy;
            return retVal;
          },
          then: Yup.string().test(
            "test-always",
            formatMessage({
              id: "ContactRelationForm.PhoneInUse",
              defaultMessage: "El teléfono ya está en uso",
            }),
            (value) => {
              return false;
            }
          ),
        }),
    }),
    Email: Yup.string().when("op", {
      is: "new",
      then: Yup.string()
        .required(
          formatMessage({
            id: "ContactRelationForm.emailRequired",
            defaultMessage: "El correo electrónico es obligatorio",
          })
        )
        .test(
          "valid-email",
          formatMessage({
            id: "ContactRelationForm.emailMustBeValid",
            defaultMessage: "El correo electrónico no es válido",
          }),
          validateEmail
        )
        .when("email_used_by", {
          is: (emailUsedBy) => {
            const retVal = !!emailUsedBy;
            return retVal;
          },
          then: Yup.string().test(
            "test-always",
            formatMessage({
              id: "ContactRelationForm.EmailInUse",
              defaultMessage: "El correo electrónico ya está en uso",
            }),
            (value) => {
              return false;
            }
          ),
        }),
    }),
    Parentesco: Yup.object()
      .nullable()
      .required(
        formatMessage({
          id: "ContactRelationForm.KinshipRequired",
          defaultMessage: "El parentesco es obligatorio",
        })
      )
      .shape({
        value: Yup.string().required(
          formatMessage({
            id: "ContactRelationForm.KinshipRequired",
            defaultMessage: "El parentesco es obligatorio",
          })
        ),
      }),
  });

  return validationSchema;
}
